import { useState } from "react";
import HomeComponent from "../HomeComponent/HomeComponent";

const EditableInput = () => {
  const [value, setValue] = useState("");

  return (
    <div>
      <input type="text" value={value} onChange={(e) => setValue(e.target.value)} />
      <div>
        <HomeComponent />
      </div>
    </div>

  );
};

export default EditableInput;
